// Spin-wheel endpoints (`/rakeback/daily-spin-wheel/*`) are not yet implemented
// on the new backend. We keep the service surface so callers compile, but each
// method warns and returns a stub so the UI can render a "Coming soon" state
// instead of hitting a 404.

const GAP_WARNING =
  "[gap] spin-wheel endpoints not yet on new backend — returning stub";

const stub = () => ({ success: false, data: null });

const getSpinWheelContent = async () => {
  console.warn(GAP_WARNING);
  return stub();
};

const getDailySpinWheelSpinReward = async () => {
  console.warn(GAP_WARNING);
  return stub();
};

const redeemSpinWheelSpinReward = async () => {
  console.warn(GAP_WARNING);
  return stub();
};

const SpinService = {
  getSpinWheelContent,
  getDailySpinWheelSpinReward,
  redeemSpinWheelSpinReward,
};

export default SpinService;
